import { Component, EventEmitter, Input, Output, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { InputConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';

@Component({
    encapsulation: ViewEncapsulation.ShadowDom,
    selector: 'mc-simple-toggle',
    styleUrls: ['../../sharedStyles/base.scss', './simple-toggle.component.scss'],
    templateUrl: './simple-toggle.component.html'
})
export class SimpleToggleComponent extends BaseComponent {
    get includeGoogleAnalytics() { return false; }

    @Output() readonly toggleChange: EventEmitter<boolean> = new EventEmitter();

    @Input() toggleLabel: string;

    @Input()
    @InputConverter()
    toggleValue: boolean;

    constructor(_vcr: ViewContainerRef) { super(_vcr, true); }

    onToggleChange() {
        this.toggleChange.emit(this.toggleValue);
    }
}
